
<div :id="content.idHTML" :class="jel_getClassObject(content)">
  <GroupeRadio v-model="genre" :content="getContent()"></GroupeRadio>
</div>
